export default [
  {
    path: "/orders/index",
    name: "orders-index",
    component: () => import("@/views/orders/index.vue"),
    meta: {
      resource: "Orders",
      action: "GetOrder",
    },
  },
  {
    path: "/orders/create",
    name: "request-order",
    component: () => import("@/views/orders/Add.vue"),
    meta: {
      resource: "Order",
      action: "Create",
    },
  },
  {
    path: "/paybylink/create",
    name: "create-paybylink",
    component: () => import("@/views/orders/Paybylink/Create.vue"),
    meta: {
      resource: "Order",
      action: "CreateLink",
    },
  },
  {
    path: "/orders/Instructions/:id",
    name: "instruction-fop",
    component: () => import("@/views/orders/Instructions-fop.vue"),
    meta: {
      resource: "Instructionsfop",
      action: "view",
    },
  },
  {
    path: "/orders/paylink",
    name: "request-paylink",
    component: () => import("@/views/orders/Paybylink/index.vue"),
    meta: {
      resource: "Order",
      action: "PayByLink",
    },
  },
  {
    path: "/orders/payment-paylink",
    name: "payment-paylink",
    component: () => import("@/views/fops/paymentoptions/PaymentSelection.vue"),
    meta: {
      layout: "full",
      // redirectIfLoggedIn: true,
      resource: "PaymentLink",
      action: "annonmous",
    },
  },
  {
    path: "/orders/instructions-paylink",
    name: "instructions-paylink",
    component: () =>
      import("@/views/fops/instructions/Anonymous-instruction.vue"),
    meta: {
      layout: "full",
      resource: "instructionspaylink",
      action: "annonmous",
    },
  },
  {
    path: "/orders/detail/:id",
    name: "order-detail",
    component: () => import("@/views/orders/Detail.vue"),
    meta: {
      resource: "Order",
      action: "Detail",
    },
  },
];
